import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';

import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { ModulePermissionProps } from 'src/app/common/module/types';
import { ACTIVITY_TRACKING_BASE_PATH, QR_ACTIVITY_REPORT_PATH } from '../../constans';

import QRActivityReportListPage from './List';

const basePath = `${ACTIVITY_TRACKING_BASE_PATH}${QR_ACTIVITY_REPORT_PATH}`;

export const qrActivityReportFilterKeys = [
  'availableFrom',
  'availableTo',
  'attendanceAgentCode',
  'hostAgentCode',
  'activityName',
  'activityType',
  'category',
  'framework',
  'officeCode',
];

const QRActivityReportPage: FC<RouteComponentProps & ModulePermissionProps> = ({
  enableRead,
  enableCreate,
  enableUpdate,
}) => {
  return (
    <Switch>
      <Redirect exact from={basePath} to={`${basePath}/list`} />

      <PruRoute
        exact
        path={`${basePath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={qrActivityReportFilterKeys}>
            <QRActivityReportListPage
              enableRead={enableRead}
              enableCreate={enableCreate}
              enableUpdate={enableUpdate}
            />
          </ParamsProvider>
        )}
      />
    </Switch>
  );
};

export default QRActivityReportPage;
